import { render } from "./Complete.vue?vue&type=template&id=3aef9554"
import script from "./Complete.vue?vue&type=script&lang=js"
export * from "./Complete.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2419941712/src/fantini-forms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__